import React from 'react';
import utils from '@/common/utils';
import styles from './index.module.scss';

const DataBox = (props) => {
  return <div className={styles['data-box']}>
    <div className={styles.title}>{props.title ?? 0}：</div>
    <div className={styles.value}>{utils.numFormat(props.value ?? 0)}</div>
  </div>
};

export default DataBox;
